import axios from '../API/axios';

export const downloadInvoice = (orderID: string, type: string) => {
  return axios.get(`/order/invoices/${orderID}/${type}`);
};
